import React, { Component } from "react"
import MetaTags from 'react-meta-tags';
import PropTypes from "prop-types"
import { connect } from "react-redux"
import {
    Col,
    Container,
    Pagination,
    PaginationItem,
    PaginationLink,
    Row,
    Alert,
    Card,
    CardBody,
    CardTitle,
    Button,
    Label,
    Form, FormGroup, Input,
} from "reactstrap"
import Select from "react-select"
import { planet } from "common/data/planet"
import "flatpickr/dist/themes/material_blue.css"
import Flatpickr from "react-flatpickr"
import * as moment from 'moment'

// availity-reactstrap-validation
import { withRouter } from "react-router-dom"
import { map } from "lodash"

//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb"

//Import Cards
import CardReport from "pages/Group/Common/Report/report-card"

import { getUserBirthChartList } from "store/ProductAdmin/birthChartReport/actions"
import { isEmpty, isEqual } from "lodash"
import { API_URL } from "helpers/api_helper";

import "flatpickr/dist/themes/material_blue.css"
import { replaceAll } from 'components/Common/Util'
import { getGroupMasters, getBranches, getGroupUsers } from "store/group/reports/actions"
import PageLoader from 'pages/Common/PageLoader'

class GroupReportsPage extends Component {
    constructor(props) {
        super(props)
        this.state = {
            page: 1,
            totalPage: 10, //replace this with total pages of data
            pageSize: 10,
            sortOrder: 'desc',
            search: '',
            userName: '',
            refferedBy: '',
            mobile: '',
            city: '',
            planet:'',
            position:'',
            reportCreatedDate: '',
            reportCreatedEndDate:'',
            itemsCountPerPage: null,
            totalItemsCount: null,
            actionResult: {},
            actionResultChanged: false,
            userBirthChartList: [],
            componentMounted: false,
            loading: false,
            filterButton: false,
            clearButton: false,
            selectedBranch: [],
            selectedUser: [],
            selectedGroupMasters: [],
            optionBranch: [],
            optionUsers: [],
            optionGroupMasters: [],
            positionFilter: [],
        }
        this.handleValidSubmit = this.handleValidSubmit.bind(this)
        this.handleDownload = this.handleDownload.bind(this)
    }

    handleGroupMastersChange = selectedGroupMasters => {
        console.log("group masters->changed")
        this.setState({
            selectedUser: '',
            optionUsers: [],
            selectedBranch: '',
            optionBranch: [],
            selectedGroupMasters
        })
        const { onGetBranches } = this.props
        onGetBranches(selectedGroupMasters.value)
    }

    handleBranchChange = selectedBranch => {
        console.log("branch->changed")
        console.log("branch id: ", selectedBranch.value)
        this.setState({
            selectedUser: '',
            optionUsers: [],
            selectedBranch
        })
        const { onGetGroupUsers } = this.props
        let userType = "PRODUCT_ADMIN"
        onGetGroupUsers(selectedBranch.value, userType)
    }

    handleUserChange = selectedUser => {
        console.log("user->changed")
        console.log("user id: ", selectedUser.value)
        this.setState({ selectedUser })
    }

    componentDidMount() {
        
        console.log("componentDidMount->called")
        const { onGetUserBirthChartListPage, onGetGroupMasters } = this.props
        onGetUserBirthChartListPage(0, this.state.pageSize,
            this.state.sortOrder, this.state.reportCreatedDate, this.state.reportCreatedEndDate, this.state.planet,this.state.position,
            this.state.userName, this.state.refferedBy, this.state.city, this.state.mobile,
            this.state.selectedGroupMasters.value, this.state.selectedBranch.value, this.state.selectedUser.value)
        onGetGroupMasters()
    }

    componentDidUpdate(prevProps, prevState) {
        const { userBirthChartListPage, actionResult, groupMasters, branches, groupUsers } = this.props
        if (!isEmpty(actionResult) && !isEqual(prevProps.actionResult, actionResult)) {
            console.log("componentDidUpdate->actionResult changed")
            this.setState({ actionResult, actionResultChanged: true })
        }

        if (!isEmpty(userBirthChartListPage)) {
            console.log("componentDidUpdate");
            if (!isEqual(prevProps.userBirthChartListPage.userBirthChartList, userBirthChartListPage.userBirthChartList)
                || userBirthChartListPage.size !== this.state.itemsCountPerPage) {
                console.log("componentDidUpdate->birthChartListPageChanged");
                this.setState({
                    userBirthChartList: userBirthChartListPage.userBirthChartList,
                    //totalPage: userBirthChartListPage.totalPages,
                    totalItemsCount: userBirthChartListPage.totalElements,
                    itemsCountPerPage: userBirthChartListPage.size,
                    totalPage: userBirthChartListPage.totalPages > 10 ? 10 : userBirthChartListPage.totalPages,
                })
            }
        }

        if (!isEmpty(groupMasters) && !isEqual(prevProps.groupMasters, groupMasters)) {
            this.setState({ optionGroupMasters: groupMasters })
            console.log("setState->called->groupMasters")
        }

        if (!isEmpty(branches) && !isEqual(prevProps.branches, branches)) {
            this.setState({ optionBranch: branches })
            console.log("setState->called->branches")
        }

        if (!isEmpty(groupUsers) && !isEqual(prevProps.groupUsers, groupUsers)) {
            this.setState({ optionUsers: groupUsers })
            console.log("setState->called->groupUsers")
        }
    }

    handlePageClick = page => {
        this.setState({ page })
        const { onGetUserBirthChartListPage } = this.props
        let createdDate = new Date(this.state.reportCreatedDate);
        let formattedDate = createdDate.getFullYear() + '-' + String(createdDate.getMonth() + 1).padStart(2, '0') + '-' + String(createdDate.getDate()).padStart(2, '0');

        let createdEndDate = new Date(this.state.reportCreatedEndDate);
        let formattedEndDate = createdEndDate.getFullYear() + '-' + String(createdEndDate.getMonth() + 1).padStart(2, '0') + '-' + String(createdEndDate.getDate()).padStart(2, '0');

        onGetUserBirthChartListPage(page - 1, this.state.pageSize, this.state.sortOrder,
            formattedDate,  formattedEndDate , this.state.planet,this.state.position, this.state.userName, this.state.refferedBy, this.state.city, this.state.mobile,
            this.state.selectedGroupMasters.value, this.state.selectedBranch.value, this.state.selectedUser.value)
    }

    handleDownload(birthChartId, birthChartName) {
        this.setState({ loading: true }, function () {
            console.log("state updaed loading", this.state.loading)
            console.log("inside the report details method::::::: birth chart report")
            console.log("birthChartId", birthChartId)
            console.log("birthChartName", birthChartName)
            try {
                const birthReportUrl = "product/birthChart/PDF"
                const obj = JSON.parse(sessionStorage.getItem("authUser"))
                const config = {
                    method: 'GET', // *GET, POST, PUT, DELETE, etc.
                    mode: 'cors', // no-cors, *cors, same-origin
                    cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
                    headers: {
                        'Authorization': 'Bearer ' + obj.token
                    },
                }
                const GROUP = "GROUP"
                fetch(`${API_URL}/${birthReportUrl}?id=${birthChartId}&userType=${GROUP}`, config)
                    .then(response => {
                        if (response.status != 200) {
                            return
                        }
                        const filename = "AIReport_" + replaceAll(birthChartName);
                        console.log("filename", filename)
                        response.blob().then(blob => {
                            let url = window.URL.createObjectURL(blob);
                            let a = document.createElement('a');
                            a.href = url;
                            a.download = filename;
                            a.click();
                        });
                        this.setState({ loading: false })
                    });
            } catch (error) {
                console.log(error)
            }
        });
    }

    handleCreatedDateChange = date => {
        this.setState({
            startDate: date,
        })
    }

    handleValidSubmit(event, values) {
        event.preventDefault()


        console.log("form submit values" + values)
        if (this.state.filterButton) {
            // this.setState({
            //     page: 1,
            //     totalPage: 0,
            //     pageSize: 10,
            // })
            let createdDate = new Date(this.state.reportCreatedDate);
            let formattedDate = createdDate.getFullYear() + '-' + String(createdDate.getMonth() + 1).padStart(2, '0') + '-' + String(createdDate.getDate()).padStart(2, '0');

            let createdEndDate = new Date(this.state.reportCreatedEndDate);
            let formattedEndDate = createdEndDate.getFullYear() + '-' + String(createdEndDate.getMonth() + 1).padStart(2, '0') + '-' + String(createdEndDate.getDate()).padStart(2, '0');

            console.log("inside filter button jkkkkkk:::" +  formattedDate);

            const { onGetUserBirthChartListPage } = this.props
            onGetUserBirthChartListPage(this.state.page - 1, this.state.pageSize, this.state.sortOrder,
                formattedDate,  formattedEndDate, this.state.planet,this.state.position, this.state.userName, this.state.refferedBy, this.state.city, this.state.mobile,
                this.state.selectedGroupMasters.value, this.state.selectedBranch.value, this.state.selectedUser.value)
            console.log("inside filter button")
        } else if (this.state.clearButton) {
            console.log("inside clear button")
            this.setState({
                userName: '',
                refferedBy: '',
                mobile: '',
                city: '',
                reportCreatedDate: '',
                reportCreatedEndDate: '',
                planet:'',
                position:'',
                selectedGroupMasters:'',
                selectedBranch:'',
                selectedUser:'',
            })
            const { onGetUserBirthChartListPage, onGetGroupMasters } = this.props
            onGetUserBirthChartListPage(0, this.state.pageSize,
                this.state.sortOrder, this.state.reportCreatedDate,  this.state.reportCreatedEndDate, this.state.planet,this.state.position,
                this.state.userName, this.state.refferedBy, this.state.city, this.state.mobile,
                this.state.selectedGroupMasters.value, this.state.selectedBranch.value, this.state.selectedUser.value)
            onGetGroupMasters()
        }
    }

    renderLoader = () => {
        console.log("render loader started :::::::", this.state.loading)
        if (this.state.loading === true) {
            return (
                <PageLoader loaderMsg="Downloading report... please wait" />
            )
        }
        return null
    }

    render() {

        const positionOptions = [
            { value: '1', label: '1' }, { value: '2', label: '2' }, { value: '3', label: '3' },
            { value: '4', label: '4' }, { value: '5', label: '5' }, { value: '6', label: '6' },
            { value: '7', label: '7' }, { value: '8', label: '8' }, { value: '9', label: '9' },
            { value: '10', label: '10' }, { value: '11', label: '11' }, { value: '12', label: '12' }
          ]

        const planetOptions = [{"value":"Sun","label":"Sun"},{"value":"Moon","label":"Moon"},{"value":"Mercury","label":"Mercury"},
          {"value":"Venus","label":"Venus"},{"value":"Mars","label":"Mars"},{"value":"Jupiter","label":"Jupiter"},
          {"value":"Saturn","label":"Saturn"},{"value":"Ascendant","label":"Ascendant"},{"value":"Rahu","label":"Rahu"},
          {"value":"Ketu","label":"Ketu"}]

        const { page, totalPage, userBirthChartList, actionResult, loading } = this.state
        console.log(userBirthChartList)
        let userRoles = {
            user: false,
            groupUser: false,
            productAdmin: false,
        }

        return (
            <div className="page-content">
                {this.renderLoader()}
                <MetaTags>
                    <title>View Artificial Intelligence Reports | Kattam </title>
                </MetaTags>
                <Container fluid>
                    <Breadcrumbs title="View AI Reports" breadcrumbItem="Group User" />

                    <Row>
                        <Col lg={12}>
                            <Card>
                                <CardBody>
                                    <Form onSubmit={this.handleValidSubmit}>
                                        <Row>
                                            <Col lg="4">
                                                <FormGroup>
                                                    <Label>Group</Label>
                                                    <Select
                                                        value={this.state.selectedGroupMasters}
                                                        options={this.state.optionGroupMasters}
                                                        //options={this.props.groupMasters}
                                                        onChange={this.handleGroupMastersChange}
                                                        classNamePrefix="select2-selection"
                                                    />
                                                </FormGroup>
                                            </Col>
                                            <Col lg="4">
                                                <FormGroup>
                                                    <Label>Branch</Label>
                                                    <Select
                                                        value={this.state.selectedBranch}
                                                        options={this.props.branches}
                                                        onChange={this.handleBranchChange}
                                                        classNamePrefix="select2-selection"
                                                    />
                                                </FormGroup>
                                            </Col>
                                            <Col lg="4">
                                                <FormGroup>
                                                    <Label>User</Label>
                                                    <Select
                                                        value={this.state.selectedUser}
                                                        options={this.state.optionUsers}
                                                        onChange={this.handleUserChange}
                                                        classNamePrefix="select2-selection"
                                                    />
                                                </FormGroup>
                                            </Col>
                                                                                   
                                        </Row>

                                        <Row className="mt-3">

                                            <Col sm="6" className="col-xl">
                                                <FormGroup>
                                                    <Label>Name</Label>
                                                    <Input
                                                        name="userName"
                                                        id="userName"
                                                        className="form-control"
                                                        placeholder="Name"
                                                        type="text"
                                                        onChange={(e) => {
                                                            this.setState({ userName: e.target.value })
                                                        }}
                                                        value={this.state.userName}
                                                    />
                                                </FormGroup>
                                            </Col>
                                            <Col sm="6" className="col-xl">
                                                <FormGroup>
                                                    <Label>Reffered by</Label>
                                                    <Input
                                                        name="refferedBy"
                                                        id="refferedBy"
                                                        className="form-control"
                                                        placeholder="Reffered by"
                                                        type="text"
                                                        onChange={(e) => {
                                                            this.setState({ refferedBy: e.target.value })
                                                        }}
                                                        value={this.state.refferedBy}
                                                    />
                                                </FormGroup>
                                            </Col>
                                            <Col sm="6" className="col-xl">
                                                <FormGroup>
                                                    <Label>Mobile</Label>
                                                    <Input
                                                        name="mobile"
                                                        id="mobile"
                                                        className="form-control"
                                                        placeholder="Mobile"
                                                        type="text"
                                                        validate={{
                                                            pattern: { value: '^[0-9]{8,10}$', errorMessage: 'Please enter a valid mobile.' }
                                                        }}
                                                        onChange={(e) => {
                                                            this.setState({ mobile: e.target.value })
                                                        }}
                                                        value={this.state.mobile}
                                                    />
                                                </FormGroup>
                                            </Col>
                                            <Col sm="6" className="col-xl">
                                                <FormGroup>
                                                    <Label>City</Label>
                                                    <Input
                                                        name="city"
                                                        id="city"
                                                        className="form-control"
                                                        placeholder="City"
                                                        type="text"
                                                        onChange={(e) => {
                                                            this.setState({ city: e.target.value })
                                                        }}
                                                        value={this.state.city}
                                                    />
                                                </FormGroup>
                                            </Col>
                                            <Col sm="6" className="col-xl">
                                        </Col>
                                        </Row>

                                        <Row className="mt-3">
                                           
                                            <Col sm="6" className="col-xl">
                                            <div className="form-group">
                                                    <label>Created Date : Start Date</label>
                                                    <div className="input-group">
                                                        <Flatpickr
                                                        value = {this.state.reportCreatedDate}
                                                            className="form-control d-block"
                                                            placeholder="Start Date"
                                                            options={{
                                                                altInput: true,
                                                                altFormat: "d-m-Y",
                                                                dateFormat: "Y-m-d",
                                                                allowInput: false,
                                                                locale: "en",
                                                                parseDate: function(dateStr) {
                                                                    return moment("Y-m-d", "yyyy-MM-dd").toDate();
                                                                }
                                                              
                                                              //defaultDate: "today",
                                                            }}
                                                            onChange={date => {
                                                                
                                                                console.log('inside the on change:::::',  date);
                                                                this.setState({ reportCreatedDate:date });
                                                                console.log('inside the on change after state:::::',this.state.reportCreatedDate);
                                                            }}
                                                        />
                                                    </div>
                                                    
                                                </div>
                                            </Col>
                                            <Col sm="6" className="col-xl">
                                            <div className="form-group">
                                                    <label>End Date</label>
                                                    <div className="input-group">
                                                        <Flatpickr
                                                            value = {this.state.reportCreatedEndDate}
                                                            className="form-control d-block"
                                                            placeholder="End Date"
                                                            options={{
                                                                altInput: true,
                                                                altFormat: "d-m-Y",
                                                                dateFormat: "Y-m-d",
                                                                allowInput: false,
                                                                locale: "en",
                                                                parseDate: function(dateStr) {
                                                                    return moment("Y-m-d", "yyyy-MM-dd").toDate();
                                                                }
                                                              
                                                              //defaultDate: "today",
                                                            }}
                                                            onChange={date => {
                                                                
                                                                console.log('inside the on change:::::',  date);
                                                                this.setState({ reportCreatedEndDate:date });
                                                                console.log('inside the on change after state:::::',this.state.reportCreatedEndDate);
                                                            }}
                                                        />
                                                    </div>
                                                    
                                                </div>
                                            </Col>
                                            <Col sm="6" className="col-xl">
                                            <FormGroup>
                                                    <Label>Planet</Label>
                                                    <Select
                                                        //value={this.state.planet}
                                                        options={planetOptions}
                                                        onChange={(selectedPlanet) => {
                                                            this.setState({ planet: selectedPlanet.value })
                                                        }}
                                                        //options={this.props.groupMasters}
                                                        //onChange={this.handleGroupMastersChange}
                                                        classNamePrefix="select2-selection"
                                                    />
                                                </FormGroup>

                                            
                                            </Col>
                                            <Col sm="6" className="col-xl align-self-end">
                                            <FormGroup>
                                                    <Label>Position</Label>
                                                    <Select
                                                        //value={this.state.position}
                                                        options={positionOptions}
                                                        //options={this.props.groupMasters}
                                                        //onChange={this.handleGroupMastersChange}
                                                        classNamePrefix="select2-selection"
                                                        name="positionfilter" id="positionfilter"
                                                        onChange={(selectedPosition) => {
                                                            this.setState({ position: selectedPosition.value })
                                                        }}
                                                    
                                                        />
                                                </FormGroup>
                                            

                                            </Col>
                                            <Col sm="6" className="col-xl align-self-end">
                                                <div className="mt-3">
                                                    <Button
                                                        onClick={() => {
                                                            this.setState({
                                                                filterButton: true,
                                                                clearButton: false,
                                                                page: 1,
                                                                totalPage: 0,
                                                                pageSize: 10,
                                                            })
                                                        }}
                                                        type="button"
                                                        color="primary"
                                                        type="submit"
                                                        className=""
                                                    >
                                                        <i className="mdi mdi-filter me-2" />
                                                        Filter
                                                    </Button>
                                                    &nbsp;&nbsp;
                                                    <Button
                                                        onClick={() => {
                                                            this.setState({
                                                                clearButton: true,
                                                                filterButton: false,
                                                                userName: '',
                                                                refferedBy: '',
                                                                mobile: '',
                                                                city: '',
                                                                selectedUser: '',
                                                                optionUsers: [],
                                                                selectedBranch: '',
                                                                optionBranch: [],
                                                                selectedGroupMasters: '',
                                                                optionGroupMasters: []
                                                            })
                                                        }}
                                                        type="button"
                                                        color="primary"
                                                        type="submit"
                                                        className=""
                                                    >
                                                        Clear
                                                    </Button>
                                                </div>
                                            </Col>
                                        </Row>
                                    </Form>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>

                    <Row>
                        <CardReport
                            handleDownload={this.handleDownload}
                            birthChartList={userBirthChartList}
                            key={"birthChart"}
                            userRoles={userRoles}
                        />
                    </Row>

                    <Row>
                        <Col lg="12">
                            <Pagination className="pagination pagination-rounded justify-content-center mt-2 mb-5">
                                <PaginationItem disabled={page === 1}>
                                    <PaginationLink
                                        previous
                                        href="#"
                                        onClick={() => this.handlePageClick(page - 1)}
                                    />
                                </PaginationItem>
                                {map(Array(totalPage), (item, i) => (
                                    <PaginationItem active={i + 1 === page} key={'_k' + i}>
                                        <PaginationLink
                                            onClick={() => this.handlePageClick(i + 1)}
                                            href="#"
                                        >
                                            {i + 1}
                                        </PaginationLink>
                                    </PaginationItem>
                                ))}
                                <PaginationItem disabled={page === totalPage}>
                                    <PaginationLink
                                        next
                                        href="#"
                                        onClick={() => this.handlePageClick(page + 1)}
                                    />
                                </PaginationItem>
                            </Pagination>
                        </Col>
                    </Row>
                </Container>
            </div >
        )

    }
}

GroupReportsPage.propTypes = {
    userBirthChartListPage: PropTypes.object,
    userBirthChartList: PropTypes.array,
    onGetUserBirthChartListPage: PropTypes.func,
    actionResult: PropTypes.object,
}

const mapStateToProps = ({ productAdminBirthChart, grpReports }) => ({
    userBirthChartListPage: productAdminBirthChart.userBirthChartListPage,
    actionResult: productAdminBirthChart.actionResult,
    groupMasters: grpReports.groupMasters,
    groupUsers: grpReports.groupUsers,
    branches: grpReports.branches
})

const mapDispatchToProps = dispatch => ({
    onGetUserBirthChartListPage:
        (page, size, sortOrder, reportCreatedDate, reportCreatedEndDate, planet, position, userName, refferedBy, city, mobile, groupMasterId, branchId, userId) => dispatch(getUserBirthChartList
            (page, size, sortOrder, reportCreatedDate, reportCreatedEndDate, planet, position, userName, refferedBy, city, mobile, "GROUP", groupMasterId, branchId, userId)),
    onGetGroupMasters: () => dispatch(getGroupMasters()),
    onGetBranches: (groupMastersId) => dispatch(getBranches(groupMastersId)),
    onGetGroupUsers: (branchMasterId, userType) => dispatch(getGroupUsers(branchMasterId, userType)),
})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(GroupReportsPage))
